const IsMobile = /iPhone|iPad|iPod|Android/i.test(
	navigator.userAgent
) && navigator.maxTouchPoints > 0;

export default IsMobile;